import { forwardRef, type InputHTMLAttributes } from "react"
import { modifiers } from "ui-tools"
import { Icon } from "../Icon"
import s from "./Input.module.scss"

type InputProps = {
  label?: string
  infoText?: string
  disabled?: boolean
  errorMessage?: string
  isSearch?: boolean
} & InputHTMLAttributes<HTMLInputElement>

export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { label, infoText, disabled, errorMessage, isSearch, ...rest } = props

  return (
    <label className={modifiers(s, "input", { disabled, isSearch })}>
      {label}

      <div className={s.input__inputContainer}>
        {isSearch && <Icon icon="Search" className={s.input__searchIcon} />}

        <input
          ref={ref}
          className={s.input__input}
          disabled={disabled}
          {...rest}
        />
      </div>

      {errorMessage ? (
        <p className={s.input__error}>{errorMessage}</p>
      ) : infoText ? (
        <p className={s.input__info}>{infoText}</p>
      ) : null}
    </label>
  )
})
